// extracted by mini-css-extract-plugin
export default {"container":"item_container__3mRIn","image":"item_image__+EQ1k","text":"item_text__uil5C","line":"item_line__jVhSW","sidebar_image":"item_sidebar_image__-wykQ"};